import {ReportLocationHistoryModel} from "../../models/reports/ReportLocationHistoryModel";

export class ReportLocationHistoryCtrl {
    public static $inject = ['$scope','ReportLocationHistoryModel'];
    constructor(public $scope:any, public model:ReportLocationHistoryModel) {
        $scope.vm = this;
        this.$scope.$watch(() => [this.model.location],(newValue: string, oldValue: string) => {
            this.model.getCount();
        },true);
    }
}
